/* eslint-disable no-case-declarations */
export const reducer = (state, action) => {
  const { contact, files, note, name, selectedNote, dateEntered, initialState } = action.payload

  switch (action.type) {
    case 'ADD_CONTACT':
      return { ...state, contact }
    case 'ADD_DATE':
      return { ...state, dateEntered }
    case 'ADD_FILES':
      return { ...state, files: [...state.files, ...files] }
    case 'REMOVE_FILE':
      const arr = [...state.files]
      const index = arr.findIndex(f => f.name === name)
      if (~index) {
        arr.splice(index, 1)
      }
      return { ...state, files: arr }
    case 'ADD_NOTE':
      return { ...state, note }
    case 'SET_SELECTED_NOTE':
      const { contact: selectedContact, attachments } = selectedNote
      return {
        ...state,
        contact: selectedContact
          ? {
              value: selectedContact.id,
              label: selectedContact.firstName + ' ' + selectedContact.lastName
            }
          : null,
        note: selectedNote.note,
        files: attachments,
        dateEntered: selectedNote.dateEntered
      }
    case 'RESET_FORM':
      return initialState
    default:
      throw new Error()
  }
}
